export var MessageIOType;

(function (MessageIOType) {
  MessageIOType[MessageIOType["Received"] = 1] = "Received";
  MessageIOType[MessageIOType["Sent"] = 2] = "Sent";
  MessageIOType[MessageIOType["Status"] = 3] = "Status";
})(MessageIOType || (MessageIOType = {}));

export var FHTDeviceType;

(function (FHTDeviceType) {
  FHTDeviceType[FHTDeviceType["Web"] = 0] = "Web";
  FHTDeviceType[FHTDeviceType["Ios"] = 1] = "Ios";
  FHTDeviceType[FHTDeviceType["Android"] = 2] = "Android";
  FHTDeviceType[FHTDeviceType["All"] = 255] = "All";
})(FHTDeviceType || (FHTDeviceType = {}));

export var FHTMessageType;

(function (FHTMessageType) {
  FHTMessageType[FHTMessageType["Text"] = 1] = "Text";
  FHTMessageType[FHTMessageType["Image"] = 2] = "Image";
  FHTMessageType[FHTMessageType["Video"] = 3] = "Video";
  FHTMessageType[FHTMessageType["Location"] = 4] = "Location";
  FHTMessageType[FHTMessageType["Recalled"] = 5] = "Recalled";
  /* custom message */

  FHTMessageType[FHTMessageType["RichCustomMessage"] = 6] = "RichCustomMessage";
  FHTMessageType[FHTMessageType["Unsupported"] = 7] = "Unsupported";
})(FHTMessageType || (FHTMessageType = {}));